import * as VKID from "@vkid/sdk"

let configured = false

function ensureVkStatsCompatibility() {
  const marker = "__pomestoVkidStatsCompatibility"
  const currentFetch = window.fetch as typeof window.fetch & { [marker]?: boolean }
  if (currentFetch[marker]) return
  const nativeFetch = window.fetch.bind(window)
  const compatibleFetch: typeof window.fetch = async (input, init) => {
    const url = typeof input === "string" ? input : input instanceof URL ? input.href : input.url
    if (url.startsWith("https://id.vk.ru/stat_events_vkid_sdk")) {
      // VK ID 2.6.8 omits CORS headers on its optional statistics endpoint.
      void nativeFetch(input, { ...init, mode: "no-cors", credentials: "omit" }).catch(() => {})
      return new Response("{}", { status: 200, headers: { "Content-Type": "application/json" } })
    }
    return nativeFetch(input, init)
  }
  ;(compatibleFetch as typeof compatibleFetch & { [marker]?: boolean })[marker] = true
  window.fetch = compatibleFetch
}

export function configureVkId() {
  if (window.location.protocol !== "https:") return false
  ensureVkStatsCompatibility()
  if (!configured) {
    VKID.Config.init({
      app: 54760703,
      redirectUrl: "https://app.pomesto.ru/",
      responseMode: VKID.ConfigResponseMode.Callback,
      source: VKID.ConfigSource.LOWCODE,
      // VK ID показывает пользователю отдельное согласие на эти контакты.
      // Сервер сохраняет только значения, которые VK вернул после согласия.
      scope: "email phone",
    })
    configured = true
  }
  return true
}

export { VKID }
